import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { transitions } from '@twistopayments/design-system/styles'

import { responsiveFieldStyle } from '../form-field.styles'

export const root = (theme: Theme) => css`
  width: 100%;
  display: block;
  position: relative;
  ${responsiveFieldStyle(theme.presentation.field.label)}
`

export const wrapper = css`
  top: 0;
  width: 100%;
  position: absolute;
  transition: top ${transitions.default};
`

export const flexibleWrapper = (theme: Theme) => css`
  pointer-events: none;
  ${responsiveFieldStyle(theme.presentation.field.floatingLabel)}
`

export const textTransition = (theme: Theme) => css`
  overflow: hidden;
  white-space: nowrap;
  transition: color, font-size ${transitions.default};
  ${responsiveFieldStyle(theme.presentation.field.labelText)}
`

export const disabled = (theme: Theme) => css`
  color: ${theme.presentation.field.disabledCaptionColor};
`

export const placeholder = (theme: Theme) => css`
  text-overflow: ellipsis;
  ${responsiveFieldStyle(theme.presentation.field.placeholder)}
`
